import Container from 'core/display/Container'
import { AnimationSpine } from 'core/display/spines/AnimationSpine'
import { signal } from 'services/SignalsService'

export default class BonusAnimation extends Container {
  constructor(data) {
    super()
    this._data = data
    this.addChild(new AnimationSpine(data))

    this.createSignal()
    this.checkVisibility()
  }

  createSignal() {
    signal.on('STATE:IN:FS-START', this.checkVisibility.bind(this))
  }

  checkVisibility() {
    this.alpha = this._data.freespins == game.models.FreespinModel.get().all ? 1 : 0
  }

}
